import { render } from "./KeyboardTab.vue?vue&type=template&id=9764773c"
import script from "./KeyboardTab.vue?vue&type=script&lang=js"
export * from "./KeyboardTab.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9764773c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9764773c', __exports__)) {
    api.reload('9764773c', __exports__)
  }
  
  module.hot.accept("./KeyboardTab.vue?vue&type=template&id=9764773c", () => {
    api.rerender('9764773c', render)
  })

}


export default __exports__